export const DASHBOARD_ACCOUNT_WIDGET = `dashboard-account-widget`;
